<template>
  <div class="undo-replacements-container">
    <p>
      Undo replacement for the product: {{ data.product.productName }} ({{
        data.product.productCode
      }})
    </p>
    <table>
      <tr>
        <td class="status-cell"><status-icons :status="[{ name: getStatus(data.fund) }]" /></td>
        <td class="name-cell">{{ data.fund.displayName }}</td>
      </tr>
      <tr>
        <td class="status-cell">
          <status-icons :status="[{ name: getStatus(data.fund.replacement) }]" />
        </td>
        <td class="name-cell">{{ data.fund.replacement.displayName }}</td>
      </tr>
    </table>
    <div class="submit-actions">
      <button class="mds-button" type="button" @click="closeModal">
        Cancel
      </button>
      <mds-button variation="primary" @click="doUndo" class="undo-button"> Undo Replacement </mds-button>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import StatusIcons from '@/components/atoms/StatusIcons';
import { undoPendingProductFiduFundsReplacement } from '@/services/SelectReplacement';

export default {
  name: 'undo-replacement',
  components: {
    StatusIcons,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      fiduciaryNumber: (state) => state.user.fiduciary.id,
    }),
  },
  methods: {
    ...mapActions({
      closeModal: 'closeModal',
    }),
    getStatus(fund) {
      if (fund.pendingStatus) {
        return fund.pendingStatus.name;
      }
      return fund.fundStatus.name;
    },
    doUndo() {
      // eslint-disable-next-line max-len
      const payload = [
        {
          fiduciaryFundId: this.data.fund.id,
          productId: this.data.product.id,
          replacementFiduciaryFundId: this.data.fund.replacement.id,
        },
      ];
      undoPendingProductFiduFundsReplacement({
        fiduciaryNumber: this.fiduciaryNumber,
        payload,
      }).then((result) => {
        if (result.status.success) {
          // force the grid to reload
          this.$store.dispatch('setReloadNeed', true);
          this.$store.dispatch('openNotification', {
            title: 'Replacement Successfully Undone',
          });
        }
      }).catch((error) => {
        const httpStatus = (error?.response.status) ? (error?.response.status) : (error?.status);
        if (httpStatus === 401) {
          this.$router.push('/Login');
        }
      }).finally(() => {
        this.closeModal();
      });
    },
  },
};
</script>
<style lang="scss">
.undo-replacements-container {
  @include mds-body-text-m();
  table {
    margin: $mds-space-inset-2-x 0 $mds-space-inset-4-x;
    td {
      padding: $mds-space-inset-1-x 0;
    }
    .status-cell {
      padding: 0 $mds-space-inset-1-x;
    }
  }

  .undo-button {
    margin-left: $mds-space-1-and-a-half-x;
  }
}
</style>
